import { useLayoutEffect, useSyncExternalStore } from 'react';

// A route-scoped, ephemeral title. File metadata never lives in persistent storage.
const titles = new Map<string, { owner: object; title: string }>();
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(listener => listener());
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };

export function usePageMetadataTitle(pathname: string) {
  return useSyncExternalStore(subscribe, () => titles.get(pathname)?.title, () => undefined);
}

export function usePublishPageMetadataTitle(pathname: string, title?: string) {
  useLayoutEffect(() => {
    if (!title) return;
    const owner = {};
    titles.set(pathname, { owner, title });
    notify();
    return () => {
      if (titles.get(pathname)?.owner === owner) { titles.delete(pathname); notify(); }
    };
  }, [pathname, title]);
}

export const isFileViewerRoute = (pathname: string) => /^(?:\/view\/(?:employee\/file|user\/file|file)\/[^/]+(?:\/[^/]+)?|\/casefile\/file\/[^/]+)\/?$/.test(pathname);

// Display only: retain the server filename for downloads and storage.
export const friendlyFileName = (name: string) => /^training[-_ ]certificate[-_ ][0-9a-f-]+\.pdf$/i.test(name) ? "Training certificate" : name;
